interface StatusMessage {
    chathost: string;
    action: string;
    state?: string;
    status?: boolean;
}

import { URLExtraParams, PossibleActions, ToastNotificationType, Translation } from '../typings';
import Ajax from '../lib/ajax';
import Toast from './toast-notification';
import translate from './translate';
import { FAVORITE_ADDED, FAVORITE_REMOVED, FAVORITE_AND_ALERT_ADDED, NOTE_ADDED } from '../constants';

const doRequest = (url: string, data: FormData): Promise<boolean> => {
    const request = new Ajax();

    return request
        .postFormData(url, data)
        .then(() => {
            return true;
        })
        .catch(() => {
            return false;
        });
};

export const prepareData = (chathostID: string, action: PossibleActions, params: URLExtraParams): Promise<boolean> => {
    const note: string | undefined = params.note;
    const state: string | undefined = params.state;

    const url = '/fav.html';

    const formData = new FormData();
    formData.append('ci', chathostID);
    formData.append('action', action);

    if (typeof note !== 'undefined') {
        formData.append('note', note);
    }

    if (state) {
        formData.append('state', state);
    }

    return doRequest(url, formData);
};

export const displayStatusMessage = (params: StatusMessage): void => {
    let result: { message: Translation; messageType: ToastNotificationType } = {
        message: 705,
        messageType: 'error',
    };

    if (params.action === 'note' && params.status === NOTE_ADDED) {
        result = {
            message: [704, params.chathost],
            messageType: 'success',
        };
    }

    if (params.action === 'fav') {
        switch (params.state) {
            case FAVORITE_ADDED:
                result = {
                    message: [703, params.chathost],
                    messageType: 'success',
                };
                break;
            case FAVORITE_AND_ALERT_ADDED:
                result = {
                    message: [702, params.chathost],
                    messageType: 'success',
                };
                break;
            case FAVORITE_REMOVED:
                result = {
                    message: [701, params.chathost],
                    messageType: 'success',
                };
                break;
        }
    }

    Toast.show({
        message: translate(result.message),
        type: result.messageType,
        hideAfter: 2000,
    });
};
